import { FC } from "react"
import If from "../../../if"
import { BBColumnDef, RateFlowDetails } from "../../../../../types"
import NameCell from "./cells/name"
import IsDefaultCell from "./cells/is-default"
import StatusCell from "./cells/status"
import Table from "../../../table"

interface Props {
  data: RateFlowDetails[]
  isFetching: boolean
  onSelect: (val: string) => void
}

const RateflowTable: FC<Props> = ({ data, isFetching, onSelect }) => {
  const columns: BBColumnDef<RateFlowDetails>[] = [
    {
      id: "name",
      header: "Name",
      accessorFn: row => row.name,
      footer: props => props.column.id,
      cell: props => <NameCell info={props.row.original} onSelect={onSelect} />
    },
    {
      id: "status",
      header: "Status",
      accessorFn: row => row.active,
      footer: props => props.column.id,
      cell: props => <StatusCell info={props.row.original} />
    },
    {
      id: "is_default",
      header: "Default",
      accessorFn: row => row.default,
      footer: props => props.column.id,
      cell: props => <IsDefaultCell info={props.row.original} />
    }
  ]

  return (
    <div>
      <If
        condition={!data?.length && !isFetching}
        then={<div>No rate flows found.</div>}
        else={
          <Table
            isLoading={isFetching}
            data={data}
            columns={columns}
            viewType="table"
            shrinkFilterSort
            noHeader
            searchBarVisible={false}
            defaultSortBy="created"
            defaultSortDir="desc"
          />
        }
      />
    </div>
  )
}

export default RateflowTable
